import React, { FC } from 'react';
import { IMultiRadioButton } from '@common/types/element';
import { View } from 'react-native';
import connectorInput from '../ConnectorInput';
import CustRadioBox from './CustRadioBox';

const RadioBox: FC<IMultiRadioButton> = (attributes) => {
  return (
    <View style={{ width: attributes.width }}>
      <CustRadioBox {...attributes} />
    </View>
  );
};

export default connectorInput(RadioBox);
